import { render } from "./additional-services-new.vue?vue&type=template&id=a6dc04d8"
import script from "./additional-services-new.js?vue&type=script&lang=js"
export * from "./additional-services-new.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__